export const containerOptions = { autoClose: 5000, limit: 4, hideProgressBar: false };
export const toastOptions = {
  style: { fontFamily: 'Poppins' },
};
